import { readStoredPortalAccount } from '@/lib/auth/session-storage'

export function isOidcIdpReadOnly() {
  return readStoredPortalAccount('admin').role === 'viewer'
}
